import React from "react";
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import './alertComp.css';

export function AlertComp({ tipo, titulo, msg, customIcon, open, onClose }) {
  return (
    <>
    {/* espacios */}
    {Array(1).fill('\u00A0').map((_, i) => (
      <span key={i}>&nbsp;</span>
    ))} 

    <Box className="alert-box m-0 p-0 w-100">
      <Collapse in={open}>
        <Alert
          severity={tipo}
          icon={customIcon || null}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={onClose}  // Llama callback del padre
            >
              <CloseIcon />
            </IconButton>
          }
          className="custom-alert"
        >
          {titulo && <strong className="alert-title">{titulo}</strong>}
          <span className="alert-msg" dangerouslySetInnerHTML={{ __html: msg }}></span>
        </Alert>
      </Collapse>
    </Box>
    </> 
  );
}